export const DEFAULT_PAGE_TITLE = 'Mihai Anton';
export const makePageTitle = (title?: string) =>
  title ? `${title} | Mihai Anton` : DEFAULT_PAGE_TITLE;
